import React from 'react';
const ModalContext = React.createContext(false);
export default ModalContext;
